import useWorkMode from "../../hooks/useWorkMode";
import "../../styles/work-mode-toggle.css";

export default function WorkModeToggle({ variant = "header" }) {
  const { isOffline, label, setOfflineEnabled } = useWorkMode();
  const switchId = `work-mode-toggle-${variant}`;

  return (
    <div
      className={`work-mode-toggle work-mode-toggle--${variant}${
        isOffline ? " work-mode-toggle--offline" : " work-mode-toggle--online"
      }`}
    >
      <span className="work-mode-toggle__label" id={`${switchId}-label`}>
        {label}
      </span>
      <button
        type="button"
        id={switchId}
        className="work-mode-toggle__switch"
        role="switch"
        aria-checked={isOffline}
        aria-labelledby={`${switchId}-label`}
        title={
          isOffline
            ? "Offline enabled. Turn off to show Online."
            : "Online. Turn on to show Offline."
        }
        onClick={() => setOfflineEnabled(!isOffline)}
      >
        <span className="work-mode-toggle__thumb" aria-hidden />
      </button>
    </div>
  );
}
